"use client";

import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { SiYoutube } from "react-icons/si";

const STORAGE_KEY = "yt-live-popup-dismissed";
// 팝업 활성화 여부 — 다른 팝업으로 교체 시 true로 변경
const POPUP_ENABLED = false;
export default function YouTubeLivePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!POPUP_ENABLED) return;

    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) {
      const dismissedAt = new Date(dismissed).getTime();
      const now = Date.now();
      const daysDiff = (now - dismissedAt) / (24 * 60 * 60 * 1000);

      // 30일 숨김인 경우
      const duration = localStorage.getItem(STORAGE_KEY + "-duration");
      if (duration === "30d" && daysDiff < 30) return;

      // 오늘 하루 숨김인 경우
      if (duration !== "30d") {
        const dismissedDate = new Date(dismissed);
        const today = new Date();
        if (
          dismissedDate.getFullYear() === today.getFullYear() &&
          dismissedDate.getMonth() === today.getMonth() &&
          dismissedDate.getDate() === today.getDate()
        ) {
          return;
        }
      }
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setOpen(true);
  }, []);

  function dismiss(duration: "1d" | "30d") {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    localStorage.setItem(STORAGE_KEY + "-duration", duration);
    setOpen(false);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            <SiYoutube className="size-6 text-red-600 shrink-0" />
            정처기 감자 유튜브 라이브
          </DialogTitle>
          <DialogDescription>
            정처기 감자와 함께하는 정보처리기사 공부
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            음악 같이 들으면서 정처기 감자는 코딩 PDF 만들고 여러분은 공부해요!
            <br />
            정보 공유, 질문, 제안점 무엇이든 나누면서 가요
          </p>

          {/* 라이브 시간표 */}
          <div className="rounded-lg border bg-muted/50 p-4 space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">아침 라이브</span>
              <span>오전 9시 ~ 오전 11시 30분</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="font-medium">오후 라이브</span>
              <span>오후 1시 ~ 오후 5시</span>
            </div>
            <div className="border-t pt-2 mt-2 text-xs text-muted-foreground text-center">
              50분 공부 10분 휴식
            </div>
          </div>

          {/* 유튜브 채널 링크 */}
          <a
            href="https://www.youtube.com/@%EC%A0%95%EC%B2%98%EA%B8%B0%EA%B0%90%EC%9E%90"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full rounded-lg bg-red-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-700 transition-colors"
          >
            <SiYoutube className="size-5" />
            유튜브 채널 바로가기
          </a>
        </div>

        {/* 숨김 버튼 */}
        <div className="flex items-center justify-center gap-3 text-xs text-muted-foreground">
          <button
            onClick={() => dismiss("1d")}
            className="hover:text-foreground transition-colors"
          >
            오늘 하루 보지 않기
          </button>
          <span>|</span>
          <button
            onClick={() => dismiss("30d")}
            className="hover:text-foreground transition-colors"
          >
            30일간 보지 않기
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
